import styled from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import { colors } from '../../styles/vars/colors.style'
import { TextBody } from '../../styles/vars/textStyles.style'
import { mq } from '../../styles/vars/media-queries.style'
import { easings } from '../../styles/vars/easings.style'

export const SummaryBackgroundWrap = styled.div`
  background-color: ${colors.light};
  bottom: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
`

export const SummaryMain = styled.div`
  color: ${colors.light};
  overflow: hidden;
  position: relative;
  z-index: 2;
`

export const SummaryBackground = styled.div`
  background-image: url('${props => props.bg}');
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
`

export const SummaryCopy = styled.div`
  a,
  button {
    margin-bottom: 0.5rem;
    ${clamp(
      'margin-top',
      30,
      48,
      breakpoints.desk,
      breakpoints.contained,
      true
    )}
  }
`

export const SummaryExtraCopy = styled.div`
  ${TextBody} {
    font-size: 1.6rem;

    a {
      transition: color 0.4s ${easings.inOut.quart};

      &:hover {
        color: ${colors.orange};
      }
    }
  }
`

export const SummaryStats = styled.div`
  padding-bottom: 4.3rem;
  padding-top: 4.6rem;

  ${mq.tabletL} {
    padding-bottom: 0;
    padding-top: 0;
  }

  ${mq.desk} {
    ${clamp(
      'padding-left',
      80,
      130,
      breakpoints.desk,
      breakpoints.contained,
      true
    )};
  }
`
